export default __webpack_public_path__ + "static/media/wifi.16631a37.svg";